import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const SuccessPage = ({
  title = "Payment Method Added",
  des = "You have successfully added a payment method. You can safely close this window now.",
}: {
  title?: string;
  des?: string;
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="max-w-[600px] mx-auto flex flex-col items-center">
        <img src="/payment-success.png" className="w-48" alt="success" />
        <Typography.Title level={3}>{title}</Typography.Title>
        <Typography.Text type="secondary" className="text-lg text-center">
          {des}
        </Typography.Text>
      </div>
    </div>
  );
};

export default SuccessPage;
